/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  CurveMetaPoolFactoryFetcher,
  CurveMetaPoolFactoryFetcherInterface,
} from "../CurveMetaPoolFactoryFetcher";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "_repository",
        type: "address",
      },
      {
        internalType: "contract ICurveAddressProviderLike",
        name: "_addressProvider",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "EmptyAddressProvider",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidPriceProviderRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlyManager",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistryIsTheSame",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "enum RegistryId",
        name: "id",
        type: "uint8",
      },
    ],
    name: "RegistryNotFoundById",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract ICurveAddressProviderLike",
        name: "curveAddressProvider",
        type: "address",
      },
      {
        indexed: false,
        internalType: "enum RegistryId",
        name: "registryId",
        type: "uint8",
      },
    ],
    name: "DataFetcherCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "registry",
        type: "address",
      },
    ],
    name: "RegistryUpdated",
    type: "event",
  },
  {
    inputs: [],
    name: "ADDRESS_PROVIDER",
    outputs: [
      {
        internalType: "contract ICurveAddressProviderLike",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "REGISTRY_ID",
    outputs: [
      {
        internalType: "enum RegistryId",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "curveLPTokensDetailsFetcherPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_lpToken",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "getLPTokenDetails",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "addr",
                type: "address",
              },
              {
                internalType: "bool",
                name: "isMeta",
                type: "bool",
              },
            ],
            internalType: "struct Pool",
            name: "pool",
            type: "tuple",
          },
          {
            internalType: "address[]",
            name: "coins",
            type: "address[]",
          },
        ],
        internalType: "struct LPTokenDetails",
        name: "details",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "registry",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "updateRegistry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type CurveMetaPoolFactoryFetcherConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: CurveMetaPoolFactoryFetcherConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class CurveMetaPoolFactoryFetcher__factory extends ContractFactory {
  constructor(...args: CurveMetaPoolFactoryFetcherConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "CurveMetaPoolFactoryFetcher";
  }

  deploy(
    _repository: string,
    _addressProvider: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<CurveMetaPoolFactoryFetcher> {
    return super.deploy(
      _repository,
      _addressProvider,
      overrides || {}
    ) as Promise<CurveMetaPoolFactoryFetcher>;
  }
  getDeployTransaction(
    _repository: string,
    _addressProvider: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _repository,
      _addressProvider,
      overrides || {}
    );
  }
  attach(address: string): CurveMetaPoolFactoryFetcher {
    return super.attach(address) as CurveMetaPoolFactoryFetcher;
  }
  connect(signer: Signer): CurveMetaPoolFactoryFetcher__factory {
    return super.connect(signer) as CurveMetaPoolFactoryFetcher__factory;
  }
  static readonly contractName: "CurveMetaPoolFactoryFetcher";
  public readonly contractName: "CurveMetaPoolFactoryFetcher";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): CurveMetaPoolFactoryFetcherInterface {
    return new utils.Interface(_abi) as CurveMetaPoolFactoryFetcherInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): CurveMetaPoolFactoryFetcher {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as CurveMetaPoolFactoryFetcher;
  }
}
